import {MentalSymbol, MentalSymbolStates} from "./MentalSymbol";
import {MentalLayerSet} from "./MentalReelAreaView";
import {Positionable} from "../../framework/reel/ReelModel";
import {TimelineLite} from "gsap";
import {Mental} from "../Mental";
import {MentalGameAssets} from "../MentalGameAssets";

export class MentalBaseSymbol implements MentalSymbol, Positionable {
    public layerSet: MentalLayerSet;
    public offsetPosition: PIXI.ObservablePoint;
    public position: PIXI.ObservablePoint;
    public scale: PIXI.ObservablePoint;
    public symbolName: string;

    public _yOffset: number = 0;

    public currentTextureState: PIXI.Sprite | PIXI.spine.Spine;
    public currentSymbolHeight: number;

    constructor(name: string) {
        this.symbolName = name;
        this.layerSet = new MentalLayerSet("Symbol_" + this.symbolName);
        this.position = new PIXI.ObservablePoint(this.onPosition, this, 0, 0);
        this.offsetPosition = new PIXI.ObservablePoint(this.onFakePosition, this, 0, 0);
        this.scale = new PIXI.ObservablePoint(() => {}, this, 1, 1);
    }

    public static createSpinSprite(name: string): PIXI.Sprite {
        const sprite = new PIXI.Sprite(Mental.assetLoader.getTextures(MentalGameAssets.getSymbolStateTexturePath(name, "_spin"))[0]);
        sprite.anchor.set(0, 0.5);
        sprite.position.set(0, 90);
        return sprite;
    }

    public static clearSpine(target: PIXI.spine.Spine, trackIndex: number) {
        target.state.setEmptyAnimation(trackIndex, 0);
        target.skeleton.setToSetupPose();
    }

    public static createNoWinOverlay(): PIXI.Sprite {
        const noWinSprite = new PIXI.Sprite(PIXI.Texture.WHITE);
        noWinSprite.tint = 0x000000;
        noWinSprite.alpha = 0.5;
        noWinSprite.width = 144;
        noWinSprite.height = 198;
        noWinSprite.name = "noWinOverlay";
        return noWinSprite;
    }

    public clear(): void {
        this._yOffset = 0;
        // this.scale.set(1, 1);
        this.position.set(0, 0);
        this.offsetPosition.set(0, 0);
        this.setState(MentalSymbolStates.NONE);
    }

    public setState(state: MentalSymbolStates): void {
        // throw new Error("set State needs to be implemented in subclass.");
    }

    public getNoWinAnimation(): TimelineLite {
        throw new Error("set State needs to be implemented in subclass.");
    }

    public getToggleAnimation(): TimelineLite {
        throw new Error("set State needs to be implemented in subclass.");
    }

    public getWinAnimation(): TimelineLite {
        throw new Error("set State needs to be implemented in subclass.");
    }

    public getShakeAnimation(): TimelineLite {
        return new TimelineLite();
    }

    protected onFakePosition(): void {
        this._yOffset = this.offsetPosition.y - this.position.y;
        this.onPosition();
    }

    protected onPosition(): void {
        this.layerSet.position.set(this.position.x, this.position.y + this._yOffset);
    }
}